import React, { useEffect, useState } from 'react';
import { formatearMoneda, limpiarMoneda } from '../utils/formatMoney';
import './SimuladorResponsive.css';

const API = '/api';
const ANIOS_PLAZO = [...Array.from({ length: 20 }, (_, i) => i + 1), 25];
const COLUMNA_BANCOS_IZQUIERDA = ['Afirme', 'Banamex', 'Banorte', 'Banregio'];
const COLUMNA_BANCOS_DERECHA = ['HSBC', 'Santander', 'Scotiabank'];
const TIPOS_INMUEBLE = [
  { value: 'adquisicion_vivienda', label: 'Adquisición de Vivienda' },
  { value: 'adquisicion_terreno', label: 'Adquisición de Terreno' },
  { value: 'mejora_hipoteca', label: 'Mejora de Hipoteca' },
  { value: 'liquidez', label: 'Liquidez' },
  { value: 'remodelacion', label: 'Remodelación' },
];

// El valor del crédito no puede exceder el 97% del valor del inmueble
const validarMontoCredito = (valorInmuebleStr, montoCreditoStr) => {
  const vi = Number(valorInmuebleStr);
  const mc = Number(montoCreditoStr);
  if (vi > 0 && mc > 0 && mc > vi * 0.97) {
    return 'El valor del crédito no puede exceder el 97% del valor del inmueble. Corrige el monto para continuar.';
  }
  return '';
};

// Enganche Inmueble: valor del inmueble menos el valor del crédito capturado (sin descontar
// comisión ni Apoyo Infonavit). Primer renglón de Gastos iniciales y se SUMA al TOTAL GASTOS
// INICIALES solo al mostrarlo (el motor, la mensualidad y el CAT no lo usan). null (se muestra
// "—" y no suma) si falta alguno de los dos o el crédito es mayor que el inmueble.
// Misma regla en el PDF (backend/utils/simuladorComparativoPdf.js).
const calcularEnganche = (valorInmuebleStr, montoCreditoStr) => {
  const vi = Number(valorInmuebleStr);
  const mc = Number(montoCreditoStr);
  if (!(vi > 0) || !(mc > 0) || mc > vi) return null;
  return vi - mc;
};

const st = {
  wrap: { padding: 20, maxWidth: 1200, margin: '0 auto' },
  card: { backgroundColor: '#F9FAFB', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20, marginBottom: 20 },
  title: { fontSize: 18, fontWeight: 'bold', color: '#1a3a6e', margin: '0 0 16px 0' },
  rowPlazo: { display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap', alignItems: 'flex-end' },
  field: { marginBottom: 4 },
  fieldHalf: { marginBottom: 4 },
  fieldPlazo: { marginBottom: 4 },
  fieldTipoInmueble: { marginBottom: 4 },
  fieldEscrituras: { marginBottom: 4, position: 'relative' },
  escriturasControles: { display: 'flex', gap: 6, alignItems: 'center' },
  escriturasPctWrap: { display: 'flex', alignItems: 'center', gap: 4, flex: '0 0 84px' },
  escriturasPorciento: { fontSize: 13, color: '#6b7280' },
  // Debajo del campo sin cambiar el alto de la fila (alineada abajo): no empuja los otros campos.
  escriturasMonto: { position: 'absolute', top: '100%', left: 0, marginTop: 2, fontSize: 12, lineHeight: '14px', fontWeight: '600', color: '#1a3a6e', whiteSpace: 'nowrap' },
  label: { display: 'block', fontSize: 12, fontWeight: '600', color: '#6b7280', marginBottom: 4 },
  input: { width: '100%', height: 36, padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' },
  select: { width: '100%', height: 36, padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' },
  moneyWrap: { position: 'relative' },
  moneySign: { position: 'absolute', left: 8, top: 8, color: '#6b7280', fontSize: 13 },
  moneyInput: { width: '100%', height: 36, padding: '6px 8px 6px 20px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' },
  checkboxGrid: { display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 12 },
  checkLabel: { fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 10px' },
  checkLabelInline: { fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 10px', height: 36, boxSizing: 'border-box' },
  bancoGrupo: { marginBottom: 10 },
  bancoNombre: { fontSize: 13, fontWeight: '700', color: '#1a3a6e', marginBottom: 6 },
  bancoTiposCol: { display: 'flex', flexDirection: 'column', gap: 4, paddingLeft: 4 },
  checkLabelTipoCredito: { fontSize: 13, display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer', backgroundColor: 'white', border: '1px solid #d1d5db', borderRadius: 4, padding: '4px 7px', boxSizing: 'border-box' },
  tasasOpciones: { display: 'flex', flexDirection: 'column', gap: 2, margin: '3px 0 4px 18px' },
  checkTasa: { fontSize: 12.5, display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', color: '#1a3a6e' },
  avisoTope: { color: '#b45309', fontSize: 12.5, fontWeight: 600, margin: '4px 0 8px' },
  thTasa: { fontSize: 11.5, fontWeight: '700', marginTop: 3 },
  notas: { marginTop: 16, backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: 8, padding: '12px 16px' },
  notasTitulo: { margin: '0 0 8px', fontSize: 14, fontWeight: 700, color: '#1a3a6e', borderBottom: '1px solid #1a3a6e', paddingBottom: 4 },
  notaLinea: { fontSize: 13, color: '#374151', margin: '4px 0', whiteSpace: 'pre-line' },
  btnPrimary: { padding: '10px 20px', backgroundColor: '#1a3a6e', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: '600' },
  btnSecondary: { padding: '10px 20px', backgroundColor: 'white', color: '#1a3a6e', border: '1px solid #1a3a6e', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: '600' },
  error: { color: '#dc2626', fontSize: 12.5, marginTop: 8 },
  avisoPromocion: { backgroundColor: '#ecfdf5', border: '1px solid #6ee7b7', borderRadius: 6, padding: '10px 12px', fontSize: 13, color: '#047857', fontWeight: 600, marginBottom: 16 },
  avisoVacio: { backgroundColor: '#fff8e1', border: '1px solid #f5d67a', borderRadius: 6, padding: '10px 12px', fontSize: 13, color: '#7a5b00' },
  tableWrap: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 600 },
  thConcepto: { textAlign: 'left', padding: '14px 10px', backgroundColor: '#1a3a6e', color: 'white', fontWeight: '600', fontSize: 12.5, position: 'sticky', left: 0 },
  th: { textAlign: 'center', padding: '10px 10px', backgroundColor: '#1a3a6e', color: 'white', fontWeight: '600', fontSize: 12.5, minWidth: 160, height: 56 },
  thBanco: { fontSize: 13, fontWeight: '700', marginBottom: 3 },
  thTipo: { fontSize: 11, fontWeight: '500', lineHeight: 1.25, opacity: 0.92 },
  thPlazo: { fontSize: 12, fontWeight: '700', marginTop: 4, paddingTop: 4, borderTop: '1px solid rgba(255,255,255,0.35)' },
  modalFondo: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modalCaja: { backgroundColor: 'white', borderRadius: 10, padding: 24, width: '100%', maxWidth: 460, boxShadow: '0 10px 30px rgba(0,0,0,0.25)' },
  modalTitulo: { margin: '0 0 8px', color: '#1a3a6e', fontSize: 17 },
  modalTexto: { fontSize: 14, color: '#374151', margin: '0 0 16px' },
  modalPlazosGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))', gap: 8, marginBottom: 12 },
  modalAcciones: { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16, flexWrap: 'wrap' },
  tdConcepto: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', color: '#374151', position: 'sticky', left: 0, backgroundColor: 'white' },
  td: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', color: '#111827', textAlign: 'right' },
  seccion: { padding: '8px 10px', backgroundColor: '#eef2f7', fontWeight: '700', color: '#1a3a6e', fontSize: 12.5 },
  destacado: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', textAlign: 'right', fontWeight: '700', backgroundColor: '#fff8e1' },
  destacadoConcepto: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', fontWeight: '700', backgroundColor: '#fff8e1', position: 'sticky', left: 0 },
  tdMejor: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', color: '#1a3a6e', textAlign: 'right', fontWeight: '700' },
  destacadoMejor: { padding: '8px 10px', borderBottom: '1px solid #e5e7eb', textAlign: 'right', fontWeight: '700', backgroundColor: '#fff8e1', color: '#1a3a6e' },
  notaAfirme: { padding: '2px 10px 8px', borderBottom: '1px solid #e5e7eb', textAlign: 'right', fontSize: 10.5, fontStyle: 'italic', color: '#9ca3af' },
  empty: { color: '#6b7280', fontSize: 13, padding: 20, textAlign: 'center' },
  accionesResultado: { display: 'flex', justifyContent: 'flex-end', marginBottom: 10 },
};

const money = (v) => `$${formatearMoneda(String(Math.round(Number(v))), 0)}`;

// Determina, por renglón, qué resultado(s) tienen el valor más bajo (mejor
// oferta) para resaltarlos en rojo. Comparación por-renglón e independiente
// entre renglones, sobre el valor YA redondeado tal como se muestra en
// pantalla (para que un empate visual, ej. dos bancos en 9.20% después de
// redondear, cuente como empate real). Ignora valores null/no numéricos
// (ej. CAT sin dato) y no resalta nada si solo hay una oferta a comparar.
const mejoresPorValor = (valores) => {
  if (valores.length < 2) return valores.map(() => false);
  const validos = valores.filter((v) => v != null && Number.isFinite(v));
  if (!validos.length) return valores.map(() => false);
  const min = Math.min(...validos);
  return valores.map((v) => v != null && Number.isFinite(v) && v === min);
};

// Una Tasa Secundaria con % Aforo Mínimo/Máximo en blanco aplica sin importar
// el Aforo; si los tiene, solo aplica cuando el Aforo de la operación cae en
// ese rango (ej. Afirme Adquisición Vivienda tiene un juego de secundarias
// para Aforo <=80% y otro para Aforo >80%) — misma lógica que
// secundariaAplicaParaAforo en el backend (server.js).
const secundariaAplicaParaAforo = (s, aforoPct) => {
  if (aforoPct === null) return true;
  if (s.aforo_minimo !== null && s.aforo_minimo !== undefined && aforoPct < Number(s.aforo_minimo)) return false;
  if (s.aforo_maximo !== null && s.aforo_maximo !== undefined && aforoPct > Number(s.aforo_maximo)) return false;
  return true;
};

// Tasa base a mostrar junto a "Tasa base (...)" en el selector de tasas
// secundarias: misma prioridad que resolverTasaVigente en el backend
// (utils/simuladorTasas.js) — Tasa por Aforo (si hay rangos capturados y el
// Aforo cae en alguno) gana sobre Tasa según Plazo Total (ej. Afirme
// Adquisición Vivienda: 9.60%/9.85% según plazo, pero 10.40% sin importar el
// plazo si el Aforo es mayor a 80%); si ninguna aplica, la tasa_anual fija.
const tasaBaseVigente = (t, plazoMeses, aforoPct) => {
  const rangosAforo = t.aforo_rangos || [];
  if (aforoPct !== null && rangosAforo.length) {
    const filaAforo = rangosAforo.find(
      (r) => aforoPct >= Number(r.aforo_minimo) &&
        (r.aforo_maximo === null || aforoPct <= Number(r.aforo_maximo))
    );
    if (filaAforo) return Number(filaAforo.tasa_anual);
  }
  if (t.tasa_por_plazo_activo && plazoMeses) {
    const rangos = t.plazo_tasa_rangos || [];
    const plazoAnios = Number(plazoMeses) / 12;
    const fila = rangos.find(
      (r) => plazoAnios >= Number(r.plazo_minimo_anios) &&
        (r.plazo_maximo_anios === null || plazoAnios <= Number(r.plazo_maximo_anios))
    );
    if (fila) return Number(fila.tasa_pct);
  }
  return Number(t.tasa_anual);
};

// Si el nombre del tipo de crédito supera 20 caracteres, lo parte en 2 líneas
// (por el espacio más cercano a la mitad) para que quepa en el encabezado.
const partirNombreCredito = (texto) => {
  const t = String(texto || '');
  if (t.length <= 20) return [t];
  const mitad = Math.floor(t.length / 2);
  let corte = -1;
  for (let d = 0; d < mitad; d += 1) {
    if (t[mitad + d] === ' ') { corte = mitad + d; break; }
    if (t[mitad - d] === ' ') { corte = mitad - d; break; }
  }
  if (corte === -1) return [t];
  return [t.slice(0, corte), t.slice(corte + 1)];
};

// Plazos (en años) en que se puede cotizar una tasa: en Pago Creciente los que
// tienen renglón en pago_creciente_plazos (de la secundaria elegida, si hay;
// el backend ya no cae al de la primaria), en Pago Fijo plazos_permitidos_meses
// o, si no los restringe, todos los del selector de plazo.
const plazosDisponiblesTasa = (t, secundariaId) => {
  if (!t) return [];
  if (t.metodo_calculo === 'pago_creciente') {
    const secId = secundariaId ? Number(secundariaId) : null;
    const meses = (t.pago_creciente_plazos || [])
      .filter((p) => (p.tasa_secundaria_id == null ? null : Number(p.tasa_secundaria_id)) === secId)
      .map((p) => Number(p.plazo_meses));
    return ANIOS_PLAZO.filter((a) => meses.includes(a * 12));
  }
  if (Array.isArray(t.plazos_permitidos_meses) && t.plazos_permitidos_meses.length) {
    return ANIOS_PLAZO.filter((a) => t.plazos_permitidos_meses.map(Number).includes(a * 12));
  }
  return ANIOS_PLAZO;
};

const MAX_PLAZOS_ADICIONALES = 3;
// Máximo de columnas en selección manual (cada tasa elegida cuenta como una
// columna); "Todos" no tiene tope. Mismo valor que MAX_COLUMNAS_COMPARATIVO en server.js.
const MAX_COLUMNAS = 8;

const keyResultado = (r) => `${r.tasa_id}-${r.secundaria_id == null ? 'base' : r.secundaria_id}-${r.plazo_meses}`;

// Renglón de la tasa en el encabezado de columna, solo si el producto tiene
// tasas secundarias en el catálogo. Mismo texto que el PDF (simuladorComparativoPdf.js).
const etiquetaTasaColumna = (r) => (r.tiene_secundarias
  ? `${r.tasa_etiqueta || 'Tasa base'} – ${Number(r.tasa_anual).toFixed(2)}%`
  : '');

// Nombre de la columna para avisos/excluidos: "Banco - Producto – Tasa".
const nombreConTasa = (x) => `${x.banco} - ${x.tipo_credito}${x.tasa_etiqueta ? ` – ${x.tasa_etiqueta}` : ''}`;

const unirConY = (lista) => (lista.length <= 1 ? lista.join('') : `${lista.slice(0, -1).join(', ')} y ${lista[lista.length - 1]}`);

// Sección "Notas" (condicionantes): una línea por hipoteca con condicionante
// general (una sola vez aunque se comparen varias de sus tasas) y una por
// condicionante de tasa; si varias tasas de la misma hipoteca tienen el mismo
// texto se juntan en una línea. En modo varios plazos la misma tasa no se
// repite. Misma lógica que armarNotas en el backend (simuladorComparativoPdf.js).
const armarNotas = (resultados) => {
  const productos = new Map();
  resultados.forEach((r) => {
    if (!productos.has(r.tasa_id)) {
      productos.set(r.tasa_id, {
        nombre: `${r.banco} – ${r.tipo_credito}`,
        condicionante: (r.condicionante_producto || '').trim(),
        tasas: new Map(),
      });
    }
    const p = productos.get(r.tasa_id);
    const key = r.secundaria_id == null ? 'base' : String(r.secundaria_id);
    if (!p.tasas.has(key)) {
      p.tasas.set(key, { etiqueta: r.tasa_etiqueta || 'Tasa base', tasas: new Set(), condicionante: (r.condicionante_tasa || '').trim() });
    }
    p.tasas.get(key).tasas.add(Number(r.tasa_anual).toFixed(2));
  });
  const notas = [];
  productos.forEach((p) => {
    if (p.condicionante) notas.push({ titulo: p.nombre, texto: p.condicionante });
    const porTexto = new Map();
    p.tasas.forEach((t) => {
      if (!t.condicionante) return;
      if (!porTexto.has(t.condicionante)) porTexto.set(t.condicionante, []);
      // Si la tasa cambia entre plazos (tasa según plazo) no se pone el %.
      porTexto.get(t.condicionante).push(t.tasas.size === 1 ? `${t.etiqueta} (${[...t.tasas][0]}%)` : t.etiqueta);
    });
    porTexto.forEach((etiquetas, texto) => notas.push({ titulo: `${p.nombre} – ${unirConY(etiquetas)}`, texto }));
  });
  return notas;
};

const SimuladorComparador = () => {
  const [tasasDisponibles, setTasasDisponibles] = useState([]);
  const [valorInmueble, setValorInmueble] = useState('');
  const [montoCredito, setMontoCredito] = useState('');
  const [plazoAnios, setPlazoAnios] = useState('');
  const [tipoInmueble, setTipoInmueble] = useState('');
  const [seleccion, setSeleccion] = useState([]); // ids seleccionados
  // Tasas elegidas por producto: { [tasa_id]: ['base', '57', ...] } ('base' =
  // tasa base, o id de cat_simulador_tasas_secundarias). Sin entrada = solo la base.
  const [tasasElegidas, setTasasElegidas] = useState({});
  const [avisoColumnas, setAvisoColumnas] = useState('');
  const [todos, setTodos] = useState(false);
  const [exento, setExento] = useState(false);
  const [exentoAvaluo, setExentoAvaluo] = useState(false);
  const [escriturasPct, setEscriturasPct] = useState('');
  const [escriturasBase, setEscriturasBase] = useState('inmueble'); // 'inmueble' | 'credito'
  const [apoyoInfonavit, setApoyoInfonavit] = useState(false);
  const [sueldoBruto, setSueldoBruto] = useState('');
  const [resultados, setResultados] = useState(null);
  const [excluidos, setExcluidos] = useState([]);
  const [calculando, setCalculando] = useState(false);
  const [descargandoPdf, setDescargandoPdf] = useState(false);
  const [descargandoAmortizacion, setDescargandoAmortizacion] = useState(null); // keyResultado en curso
  const [error, setError] = useState('');
  const [errorCredito, setErrorCredito] = useState('');
  const [esquemaPago, setEsquemaPago] = useState('fijo'); // 'fijo' | 'creciente' | 'ambos'
  // "Comparar con varios plazos": modal al oprimir Comparar con una sola hipoteca.
  const [modalPlazos, setModalPlazos] = useState(null); // null | 'pregunta' | 'seleccion'
  const [plazosExtraSel, setPlazosExtraSel] = useState([]); // años adicionales elegidos
  const [plazosCalculados, setPlazosCalculados] = useState([]); // plazos (meses) del último cálculo
  const [engancheCalculado, setEngancheCalculado] = useState(null); // Enganche Inmueble del último cálculo

  const plazoMeses = plazoAnios ? Number(plazoAnios) * 12 : '';
  const aforoPctSeleccion = (() => {
    const vi = Number(limpiarMoneda(String(valorInmueble || ''), 2));
    const mc = Number(limpiarMoneda(String(montoCredito || ''), 2));
    return vi > 0 && mc > 0 ? (mc / vi) * 100 : null;
  })();

  const montoCreditoNum = Number(limpiarMoneda(String(montoCredito || ''), 2));
  const tasasFiltradas = tasasDisponibles.filter((t) => {
    if (tipoInmueble && t.aplica_tipo_inmueble !== tipoInmueble) return false;
    const esCreciente = t.metodo_calculo === 'pago_creciente';
    if (esCreciente) {
      const plazosDisponibles = (t.pago_creciente_plazos || []).map((p) => Number(p.plazo_meses));
      if (plazoMeses && !plazosDisponibles.includes(plazoMeses)) return false;
    } else if (plazoMeses && Array.isArray(t.plazos_permitidos_meses) && t.plazos_permitidos_meses.length && !t.plazos_permitidos_meses.includes(plazoMeses)) {
      return false;
    }
    if (esquemaPago === 'creciente' && !esCreciente) return false;
    if (esquemaPago === 'fijo' && esCreciente) return false;
    // 'ambos' no filtra por esquema de pago: deja pasar fijas y crecientes.
    // Mismos topes que valida el backend al calcular (server.js, calcularComparativo):
    // Aforo máximo y Monto Máximo de Crédito. Se filtran aquí también para que no
    // aparezcan como seleccionables opciones que de todos modos se excluirían al comparar.
    if (aforoPctSeleccion !== null && t.aforo_maximo_pct !== null && t.aforo_maximo_pct !== undefined && aforoPctSeleccion > Number(t.aforo_maximo_pct)) {
      return false;
    }
    if (montoCreditoNum > 0 && t.monto_maximo_credito !== null && t.monto_maximo_credito !== undefined && montoCreditoNum > Number(t.monto_maximo_credito)) {
      return false;
    }
    return true;
  });
  const bancosFiltrados = [...new Set(tasasFiltradas.map((t) => t.banco))];

  useEffect(() => {
    fetch(`${API}/simulador/tasas`)
      .then((r) => r.json())
      .then((data) => setTasasDisponibles(Array.isArray(data) ? data.filter((t) => t.activo) : []));
  }, []);

  // Tasas vigentes de un producto: las elegidas que aplican para el Aforo
  // actual (las demás no se muestran ni se mandan); si no queda ninguna, la base.
  const tasasVigentesDe = (t) => {
    const elegidas = tasasElegidas[t.id] || ['base'];
    const vigentes = elegidas.filter((k) => k === 'base' || (t.secundarias || []).some(
      (s) => String(s.id) === k && secundariaAplicaParaAforo(s, aforoPctSeleccion)
    ));
    return vigentes.length ? vigentes : ['base'];
  };

  const seleccionVigente = seleccion.filter((id) => tasasFiltradas.some((t) => t.id === id));
  const tasaPorId = (id) => tasasFiltradas.find((t) => t.id === id);
  const columnasSeleccion = seleccionVigente.reduce((acc, id) => acc + tasasVigentesDe(tasaPorId(id)).length, 0);
  const avisoTope = `Máximo ${MAX_COLUMNAS} columnas en el comparativo (cada tasa elegida cuenta como una columna). Quita alguna para agregar otra.`;

  const toggleSeleccion = (id) => {
    if (seleccion.includes(id)) {
      setSeleccion((s) => s.filter((x) => x !== id));
      setAvisoColumnas('');
      return;
    }
    const t = tasaPorId(id);
    if (columnasSeleccion + (t ? tasasVigentesDe(t).length : 1) > MAX_COLUMNAS) {
      setAvisoColumnas(avisoTope);
      return;
    }
    setAvisoColumnas('');
    setSeleccion((s) => [...s, id]);
  };

  // Marca/desmarca una tasa (base o secundaria) de un producto ya seleccionado.
  // Debe quedar al menos una marcada.
  const toggleTasaElegida = (t, key) => {
    const actuales = tasasVigentesDe(t);
    if (actuales.includes(key)) {
      if (actuales.length === 1) return;
      setAvisoColumnas('');
      setTasasElegidas((s) => ({ ...s, [t.id]: actuales.filter((k) => k !== key) }));
      return;
    }
    if (columnasSeleccion + 1 > MAX_COLUMNAS) {
      setAvisoColumnas(avisoTope);
      return;
    }
    setAvisoColumnas('');
    setTasasElegidas((s) => ({ ...s, [t.id]: [...actuales, key] }));
  };

  // "Comparar con varios plazos": solo con una hipoteca y una sola tasa elegida.
  const tasaUnica = !todos && seleccionVigente.length === 1 && columnasSeleccion === 1
    ? tasaPorId(seleccionVigente[0])
    : null;
  const secundariaUnica = tasaUnica && tasasVigentesDe(tasaUnica)[0] !== 'base' ? tasasVigentesDe(tasaUnica)[0] : null;
  const plazosExtraDisponibles = tasaUnica
    ? plazosDisponiblesTasa(tasaUnica, secundariaUnica).filter((a) => a !== Number(plazoAnios))
    : [];

  // { [tasa_id]: [null | id secundaria, ...] } solo de los productos
  // seleccionados (null = tasa base). Con "Todos" no se manda: compara solo la base.
  const secundariasSeleccionadas = () => {
    if (todos) return {};
    const r = {};
    seleccionVigente.forEach((id) => {
      r[id] = tasasVigentesDe(tasaPorId(id)).map((k) => (k === 'base' ? null : Number(k)));
    });
    return r;
  };

  // plazos: arreglo de plazos en meses (el principal primero). Solo se manda
  // plazos_meses al backend cuando son varios.
  const datosCaptura = (plazos) => ({
    valor_inmueble: limpiarMoneda(String(valorInmueble), 2),
    monto_credito: limpiarMoneda(String(montoCredito), 2),
    plazo_meses: plazoMeses,
    plazos_meses: plazos && plazos.length > 1 ? plazos : undefined,
    tipo_inmueble: tipoInmueble,
    tasa_ids: todos ? [] : seleccionVigente,
    exento_comision: exento,
    exento_avaluo: exentoAvaluo,
    escrituras_pct: escriturasPct,
    escrituras_base: escriturasBase,
    apoyo_infonavit_activo: apoyoInfonavit,
    sueldo_bruto_mensual: apoyoInfonavit ? limpiarMoneda(String(sueldoBruto), 2) : undefined,
    secundarias_seleccionadas: secundariasSeleccionadas(),
    esquema_pago: esquemaPago,
  });

  const calcular = async () => {
    setError('');
    if (!valorInmueble || !montoCredito || !plazoMeses || !tipoInmueble || escriturasPct === '') {
      setError('Captura valor del inmueble, valor del crédito, plazo, tipo de hipoteca y gastos de escrituras');
      return;
    }
    if (Number(escriturasPct) < 0 || Number(escriturasPct) > 10) {
      setError('Gastos de escrituras debe estar entre 0.0% y 10.0%');
      return;
    }
    if (!/^\d+(\.\d{1,2})?$/.test(String(escriturasPct))) {
      setError('Gastos de escrituras admite hasta 2 decimales');
      return;
    }
    const errCredito = validarMontoCredito(valorInmueble, montoCredito);
    if (errCredito) {
      setError(errCredito);
      return;
    }
    if (!todos && seleccion.length === 0) {
      setError('Selecciona al menos un tipo de crédito, o marca "Todos"');
      return;
    }
    if (!todos && columnasSeleccion > MAX_COLUMNAS) {
      setError(avisoTope);
      return;
    }
    if (apoyoInfonavit && !sueldoBruto) {
      setError('Captura el Sueldo Bruto Mensual para calcular el Apoyo Infonavit');
      return;
    }
    if (tasaUnica && plazosExtraDisponibles.length > 0) {
      setPlazosExtraSel([]);
      setModalPlazos('pregunta');
      return;
    }
    ejecutarCalculo([plazoMeses]);
  };

  const togglePlazoExtra = (anio) => {
    setPlazosExtraSel((s) => {
      if (s.includes(anio)) return s.filter((x) => x !== anio);
      if (s.length >= MAX_PLAZOS_ADICIONALES) return s;
      return [...s, anio];
    });
  };

  const confirmarPlazos = () => {
    const extras = [...plazosExtraSel].sort((a, b) => a - b).map((a) => a * 12);
    setModalPlazos(null);
    ejecutarCalculo([plazoMeses, ...extras]);
  };

  const ejecutarCalculo = async (plazos) => {
    setError('');
    setCalculando(true);
    try {
      const captura = datosCaptura(plazos);
      const r = await fetch(`${API}/simulador/calcular`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(captura),
      });
      const data = await r.json();
      if (!r.ok) { setError(data.error || 'Error al calcular'); return; }
      setResultados(data.resultados);
      setExcluidos(data.excluidos || []);
      setPlazosCalculados(plazos);
      // El backend dice si el tipo de hipoteca lleva enganche (solo Adquisición); si no, el renglón va en $0 y no suma.
      setEngancheCalculado(data.lleva_enganche === false ? 0 : calcularEnganche(captura.valor_inmueble, captura.monto_credito));
    } catch (e) {
      setError('No se pudo conectar con el servidor. Intenta de nuevo.');
    } finally {
      setCalculando(false);
    }
  };

  const descargarPdf = async () => {
    setDescargandoPdf(true);
    try {
      const plazosPdf = tasaUnica && plazosCalculados[0] === plazoMeses ? plazosCalculados : [plazoMeses];
      const r = await fetch(`${API}/simulador/comparativo-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datosCaptura(plazosPdf)),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.error || 'Error al generar el PDF');
      }
      const blob = await r.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'Comparativo-Tasas-Hipotecarias.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (e) {
      setError(e.message);
    } finally {
      setDescargandoPdf(false);
    }
  };

  const descargarAmortizacionPdf = async (res) => {
    const { tasa_id: tasaId, banco, tipo_credito: tipoCredito } = res;
    const sufijoTasa = res.secundaria_id != null ? `-${res.tasa_etiqueta}` : '';
    const plazoRes = res.plazo_meses || plazoMeses;
    setDescargandoAmortizacion(keyResultado(res));
    try {
      const r = await fetch(`${API}/simulador/amortizacion-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...datosCaptura(), plazo_meses: plazoRes, tasa_id: tasaId, secundaria_id: res.secundaria_id != null ? res.secundaria_id : undefined }),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.error || 'Error al generar la tabla de amortización');
      }
      const blob = await r.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `Amortizacion-${banco}-${tipoCredito}${sufijoTasa}-${plazoRes / 12}anios.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (e) {
      setError(e.message);
    } finally {
      setDescargandoAmortizacion(null);
    }
  };

  // Mejor (más bajo) valor por renglón entre las ofertas comparadas, para
  // resaltarlo en rojo en la tabla — ver mejoresPorValor arriba.
  const resultadosParaComparar = resultados || [];
  const multiPlazo = plazosCalculados.length > 1;
  const mejorTasa = mejoresPorValor(resultadosParaComparar.map((r) => Math.round(Number(r.tasa_anual) * 100) / 100));
  const mejorCat = mejoresPorValor(resultadosParaComparar.map((r) => (r.cat != null ? Math.round(Number(r.cat) * 10) / 10 : null)));
  const mejorMensualidad = mejoresPorValor(resultadosParaComparar.map((r) => Math.round(Number(r.mensualidad.total))));
  const mejorVidaCredito = mejoresPorValor(resultadosParaComparar.map((r) => Math.round(Number(r.mensualidad.total_vida_credito))));
  const totalGastosIniciales = (r) => Number(r.gastos_iniciales.total) + (engancheCalculado || 0);
  const mejorGastosIniciales = mejoresPorValor(resultadosParaComparar.map((r) => Math.round(totalGastosIniciales(r))));

  // Producto en el selector: casilla del producto y, si está seleccionado y
  // tiene tasas secundarias, una casilla por tasa (base + secundarias que
  // aplican para el Aforo) para comparar una o varias de la misma hipoteca.
  const renderProducto = (t) => {
    const vigentes = seleccion.includes(t.id) ? tasasVigentesDe(t) : [];
    const opcionesTasa = [
      { key: 'base', texto: `Tasa base (${tasaBaseVigente(t, plazoMeses, aforoPctSeleccion).toFixed(2)}%)` },
      ...(t.secundarias || []).filter((s) => secundariaAplicaParaAforo(s, aforoPctSeleccion))
        .map((s) => ({ key: String(s.id), texto: `${s.etiqueta} (${Number(s.tasa_pct).toFixed(2)}%)` })),
    ];
    return (
      <div key={t.id}>
        <label style={st.checkLabelTipoCredito} className="sim-check-tipo-credito">
          <input type="checkbox" checked={seleccion.includes(t.id)} onChange={() => toggleSeleccion(t.id)} />
          {t.tipo_credito}
        </label>
        {seleccion.includes(t.id) && t.secundarias && t.secundarias.length > 0 && (
          <div style={st.tasasOpciones} className="sim-tasas-opciones">
            {opcionesTasa.map((o) => {
              const marcada = vigentes.includes(o.key);
              return (
                <label key={o.key} style={st.checkTasa}>
                  <input
                    type="checkbox"
                    checked={marcada}
                    disabled={marcada && vigentes.length === 1}
                    onChange={() => toggleTasaElegida(t, o.key)}
                  />
                  {o.texto}
                </label>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const notas = resultados ? armarNotas(resultados) : [];
  // Gastos de escrituras en vivo: % × valor del inmueble o del crédito capturado (sin descontar nada). Sin monto no se muestra
  // nada: el '—' de antes se veía como una rayita azul bajo el campo (Marco, 2026-10-28).
  const baseEscrituras = Number(escriturasBase === 'credito' ? montoCredito : valorInmueble);
  const montoEscrituras = escriturasPct !== '' && baseEscrituras > 0
    ? `$${formatearMoneda((baseEscrituras * Number(escriturasPct) / 100).toFixed(2), 2)}`
    : '';

  return (
    <div style={st.wrap} className="sim-wrap">
      <div style={st.card} className="sim-card">
        <h3 style={st.title}>Simulador Comparativo de Tasas Hipotecarias</h3>
        <div style={st.rowPlazo} className="sim-row-plazo">
          <div style={st.fieldHalf} className="sim-field-half">
            <label style={st.label}>Valor del inmueble</label>
            <div style={st.moneyWrap}>
              <span style={st.moneySign}>$</span>
              <input style={st.moneyInput} value={formatearMoneda(valorInmueble, 2)} onChange={(e) => {
                const v = limpiarMoneda(e.target.value, 2);
                setValorInmueble(v);
                setErrorCredito(validarMontoCredito(v, montoCredito));
              }} placeholder="0.00" />
            </div>
          </div>
          <div style={st.fieldHalf} className="sim-field-half">
            <label style={st.label}>Valor del Crédito</label>
            <div style={st.moneyWrap}>
              <span style={st.moneySign}>$</span>
              <input style={st.moneyInput} value={formatearMoneda(montoCredito, 2)} onChange={(e) => {
                const v = limpiarMoneda(e.target.value, 2);
                setMontoCredito(v);
                setErrorCredito(validarMontoCredito(valorInmueble, v));
              }} placeholder="0.00" />
            </div>
            {errorCredito && <div style={st.error}>{errorCredito}</div>}
          </div>
          <div style={st.fieldPlazo} className="sim-field-plazo">
            <label style={st.label}>Plazo del Crédito</label>
            <select style={st.select} value={plazoAnios} onChange={(e) => setPlazoAnios(e.target.value)}>
              <option value="">Selecciona...</option>
              {ANIOS_PLAZO.map((anio) => <option key={anio} value={anio}>{anio} años</option>)}
            </select>
          </div>
          <div style={st.fieldTipoInmueble} className="sim-field-tipo-inmueble">
            <label style={st.label}>Tipo de Hipoteca</label>
            <select style={st.select} value={tipoInmueble} onChange={(e) => setTipoInmueble(e.target.value)}>
              <option value="">Selecciona...</option>
              {TIPOS_INMUEBLE.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          <div style={st.fieldEscrituras} className="sim-field-escrituras">
            <label style={st.label}>Gastos de Escrituras</label>
            <div style={st.escriturasControles}>
              <select style={st.select} value={escriturasBase} onChange={(e) => setEscriturasBase(e.target.value)}>
                <option value="inmueble">Sobre valor Inmueble</option>
                <option value="credito">Sobre valor Crédito</option>
              </select>
              <div style={st.escriturasPctWrap}>
                <input
                  type="number" step="0.01" min="0" max="10" style={st.input} aria-label="Porcentaje de gastos de escrituras"
                  value={escriturasPct}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v !== '' && (Number(v) > 10 || !/^\d*(\.\d{0,2})?$/.test(v))) return;
                    setEscriturasPct(v);
                  }}
                  placeholder="0.00"
                />
                <span style={st.escriturasPorciento}>%</span>
              </div>
            </div>
            <div style={st.escriturasMonto}>{montoEscrituras}</div>
          </div>
        </div>

        <div style={st.rowPlazo} className="sim-row-plazo">
          <div style={st.field}>
            <label style={st.checkLabelInline}>
              <input type="checkbox" checked={exento} onChange={(e) => setExento(e.target.checked)} />
              Exenta Comisión Apertura
            </label>
          </div>
          <div style={st.field}>
            <label style={st.checkLabelInline}>
              <input type="checkbox" checked={exentoAvaluo} onChange={(e) => setExentoAvaluo(e.target.checked)} />
              Exenta Avalúo
            </label>
          </div>
          <div style={st.field}>
            <label style={st.checkLabelInline}>
              <input type="checkbox" checked={apoyoInfonavit} onChange={(e) => setApoyoInfonavit(e.target.checked)} />
              Apoyo Infonavit
            </label>
          </div>
          {apoyoInfonavit && (
            <div style={st.fieldHalf} className="sim-field-half">
              <label style={st.label}>Sueldo Bruto Mensual</label>
              <div style={st.moneyWrap}>
                <span style={st.moneySign}>$</span>
                <input style={st.moneyInput} value={formatearMoneda(sueldoBruto, 2)} onChange={(e) => setSueldoBruto(limpiarMoneda(e.target.value, 2))} placeholder="0.00" />
              </div>
            </div>
          )}
        </div>

        <div style={st.fieldTipoInmueble} className="sim-field-tipo-inmueble">
          <label style={st.label}>Esquema de Pago</label>
          <select
            style={st.select}
            value={esquemaPago}
            onChange={(e) => { setEsquemaPago(e.target.value); setSeleccion([]); setTasasElegidas({}); setAvisoColumnas(''); }}
          >
            <option value="fijo">Pagos Fijos</option>
            <option value="creciente">Pagos Crecientes</option>
            <option value="ambos">Ambos (Fijos y Crecientes)</option>
          </select>
        </div>

        <div style={st.field}>
          <label style={st.label}>Tipos de crédito a comparar</label>
          {tasasDisponibles.length === 0 ? (
            <div style={st.avisoVacio}>
              Aún no hay tipos de crédito capturados en el catálogo. Ve a la pestaña
              "Catálogo de Tasas y Condiciones" y agrega al menos un renglón para poder comparar.
            </div>
          ) : !tipoInmueble ? (
            <div style={st.avisoVacio}>Selecciona el Tipo de Hipoteca para ver los créditos disponibles.</div>
          ) : tasasFiltradas.length === 0 ? (
            <div style={st.avisoVacio}>No hay créditos en el catálogo que apliquen para este tipo de hipoteca, plazo y esquema de pago.</div>
          ) : (
            <>
              <div style={st.checkboxGrid}>
                <label style={st.checkLabel}>
                  <input type="checkbox" checked={todos} onChange={(e) => setTodos(e.target.checked)} />
                  Todos
                </label>
              </div>
              {!todos && avisoColumnas && <div style={st.avisoTope}>{avisoColumnas}</div>}
              {!todos && (
                <div className="sim-selector-grid">
                  <div>
                    {COLUMNA_BANCOS_IZQUIERDA.filter((banco) => bancosFiltrados.includes(banco)).map((banco) => (
                      <div key={banco} style={st.bancoGrupo}>
                        <div style={st.bancoNombre}>{banco}</div>
                        <div style={st.bancoTiposCol}>
                          {tasasFiltradas.filter((t) => t.banco === banco).map(renderProducto)}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div>
                    {COLUMNA_BANCOS_DERECHA.filter((banco) => bancosFiltrados.includes(banco)).map((banco) => (
                      <div key={banco} style={st.bancoGrupo}>
                        <div style={st.bancoNombre}>{banco}</div>
                        <div style={st.bancoTiposCol}>
                          {tasasFiltradas.filter((t) => t.banco === banco).map(renderProducto)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {error && <div style={st.error}>{error}</div>}
        <div style={{ marginTop: 16 }}>
          <button style={st.btnPrimary} className="sim-btn-primary" onClick={calcular} disabled={calculando}>{calculando ? 'Calculando...' : 'Comparar'}</button>
        </div>
      </div>

      {excluidos.length > 0 && (
        <div style={{ ...st.avisoVacio, marginBottom: 16 }}>
          {excluidos.map((e, i) => (
            <div key={i}>{nombreConTasa(e)}{multiPlazo ? ` (${e.plazo_meses / 12} años)` : ''}: {e.motivo}</div>
          ))}
        </div>
      )}

      {resultados && resultados.some((r) => r.aviso_plazo) && (
        <div style={{ ...st.avisoVacio, marginBottom: 16, fontWeight: 600 }}>
          {resultados.filter((r) => r.aviso_plazo).map((r) => (
            <div key={keyResultado(r)}>⚠ {nombreConTasa(r.tiene_secundarias ? r : { ...r, tasa_etiqueta: '' })}{multiPlazo ? ` (${r.plazo_meses / 12} años)` : ''}: {r.aviso_plazo}</div>
          ))}
        </div>
      )}

      {resultados && resultados.some((r) => r.promocion_leyenda) && (
        <div style={st.avisoPromocion}>
          {[...new Set(resultados.map((r) => r.promocion_leyenda).filter(Boolean))].map((leyenda) => (
            <div key={leyenda}>🏷 {leyenda}</div>
          ))}
        </div>
      )}

      {resultados && (
        resultados.length === 0 ? (
          <div style={st.empty}>No hay tasas configuradas para comparar.</div>
        ) : (
          <>
          <div style={st.tableWrap}>
            <table style={st.table}>
              <thead>
                <tr>
                  <th style={st.thConcepto}>Concepto</th>
                  {resultados.map((r) => (
                    <th key={keyResultado(r)} style={st.th}>
                      <div style={st.thBanco}>{r.banco}</div>
                      {partirNombreCredito(r.tipo_credito).map((linea, i) => (
                        <div key={i} style={st.thTipo}>{linea}</div>
                      ))}
                      {etiquetaTasaColumna(r) && <div style={st.thTasa}>{etiquetaTasaColumna(r)}</div>}
                      {multiPlazo && <div style={st.thPlazo}>Plazo: {r.plazo_meses / 12} años</div>}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr><td style={st.tdConcepto}>Aforo (%)</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{Number(r.aforo_pct).toFixed(2)}%</td>)}</tr>
                <tr><td style={st.tdConcepto}>Tasa Anual (%)</td>{resultados.map((r, i) => <td key={keyResultado(r)} style={mejorTasa[i] ? st.tdMejor : st.td}>{Number(r.tasa_anual).toFixed(2)}%</td>)}</tr>
                {resultados.some((r) => r.cat != null) && (
                  <tr><td style={st.tdConcepto}>CAT (%)</td>{resultados.map((r, i) => <td key={keyResultado(r)} style={mejorCat[i] ? st.tdMejor : st.td}>{r.cat != null ? `${Number(r.cat).toFixed(1)}%` : '—'}</td>)}</tr>
                )}
                <tr><td colSpan={resultados.length + 1} style={st.seccion}>Mensualidad (mes 1, referencia)</td></tr>
                <tr><td style={st.tdConcepto}>Amortización a capital</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.capital)}</td>)}</tr>
                <tr><td style={st.tdConcepto}>Interés</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.interes)}</td>)}</tr>
                {resultados.some((r) => Number(r.mensualidad.iva_intereses) > 0) && (
                  <tr><td style={st.tdConcepto}>IVA de intereses</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.iva_intereses)}</td>)}</tr>
                )}
                {resultados.some((r) => Number(r.mensualidad.seguro_vida) > 0) && (
                  <tr><td style={st.tdConcepto}>Seguro de vida</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.seguro_vida)}</td>)}</tr>
                )}
                {resultados.some((r) => Number(r.mensualidad.seguro_danos) > 0) && (
                  <tr><td style={st.tdConcepto}>Seguro de daños</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.seguro_danos)}</td>)}</tr>
                )}
                {resultados.some((r) => Number(r.mensualidad.costo_admin) > 0) && (
                  <tr><td style={st.tdConcepto}>Costo administrativo</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.costo_admin)}</td>)}</tr>
                )}
                {resultados.some((r) => Number(r.mensualidad.seguro_desempleo_contenidos) > 0) && (
                  <tr><td style={st.tdConcepto}>Seguro de desempleo y contenidos</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.seguro_desempleo_contenidos)}</td>)}</tr>
                )}
                {resultados.some((r) => Number(r.mensualidad.iva_comision_admon_seguros) > 0) && (
                  <tr><td style={st.tdConcepto}>IVA de comisión de admón. y seguros</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.mensualidad.iva_comision_admon_seguros)}</td>)}</tr>
                )}
                <tr><td style={st.destacadoConcepto}>TOTAL MENSUALIDAD</td>{resultados.map((r, i) => <td key={keyResultado(r)} style={mejorMensualidad[i] ? st.destacadoMejor : st.destacado}>{money(r.mensualidad.total)}</td>)}</tr>
                {resultados.some((r) => r.banco === 'Afirme' && !(Number(r.mensualidad.seguro_desempleo_contenidos) > 0)) && (
                  <tr><td style={st.tdConcepto}></td>{resultados.map((r) => (
                    <td key={keyResultado(r)} style={st.notaAfirme}>
                      {r.banco === 'Afirme' && !(Number(r.mensualidad.seguro_desempleo_contenidos) > 0)
                        ? 'Seguro Desempleo y Contenidos: No aplica para este producto/destino'
                        : ''}
                    </td>
                  ))}</tr>
                )}
                {resultados.some((r) => r.mensualidad.pago_mensual_maximo != null) && (
                  <tr><td style={st.tdConcepto}>Pago Mensual Máximo</td>{resultados.map((r) => (
                    <td key={keyResultado(r)} style={st.td}>{r.mensualidad.pago_mensual_maximo != null ? money(r.mensualidad.pago_mensual_maximo) : '—'}</td>
                  ))}</tr>
                )}
                <tr><td style={st.destacadoConcepto}>TOTAL DE VIDA DEL CRÉDITO</td>{resultados.map((r, i) => <td key={keyResultado(r)} style={mejorVidaCredito[i] ? st.destacadoMejor : st.destacado}>{money(r.mensualidad.total_vida_credito)}</td>)}</tr>
                <tr><td style={st.tdConcepto}>Meses reales para liquidar</td>{resultados.map((r) => (
                  <td key={keyResultado(r)} style={st.td}>
                    {r.mensualidad.meses_para_liquidar}
                    {r.mensualidad.meses_para_liquidar < Number(r.plazo_meses || plazoMeses) ? ` (antes de los ${r.plazo_meses || plazoMeses} pactados)` : ''}
                  </td>
                ))}</tr>

                <tr><td colSpan={resultados.length + 1} style={st.seccion}>Gastos iniciales</td></tr>
                <tr><td style={st.tdConcepto}>Enganche Inmueble</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{engancheCalculado != null ? money(engancheCalculado) : '—'}</td>)}</tr>
                <tr><td style={st.tdConcepto}>Comisión de apertura</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.gastos_iniciales.comision_apertura)}</td>)}</tr>
                <tr><td style={st.tdConcepto}>Gastos SPEI/Cheque Caja</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.gastos_iniciales.gastos_spei_cheque_caja)}</td>)}</tr>
                {resultados.some((r) => r.gastos_iniciales.gastos_investigacion > 0) && (
                  <tr><td style={st.tdConcepto}>Gastos de Investigación</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.gastos_iniciales.gastos_investigacion)}</td>)}</tr>
                )}
                <tr><td style={st.tdConcepto}>Gasto de avalúo</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.gastos_iniciales.gasto_avaluo)}</td>)}</tr>
                <tr><td style={st.tdConcepto}>Gastos de escrituras</td>{resultados.map((r) => <td key={keyResultado(r)} style={st.td}>{money(r.gastos_iniciales.gastos_escrituras)}</td>)}</tr>
                <tr><td style={st.destacadoConcepto}>TOTAL GASTOS INICIALES</td>{resultados.map((r, i) => <td key={keyResultado(r)} style={mejorGastosIniciales[i] ? st.destacadoMejor : st.destacado}>{money(totalGastosIniciales(r))}</td>)}</tr>
                <tr>
                  <td style={st.tdConcepto}>Tabla de amortización</td>
                  {resultados.map((r) => (
                    <td key={keyResultado(r)} style={st.td}>
                      <button
                        style={st.btnSecondary}
                        onClick={() => descargarAmortizacionPdf(r)}
                        disabled={descargandoAmortizacion === keyResultado(r)}
                      >
                        {descargandoAmortizacion === keyResultado(r) ? 'Generando...' : '📄 Ver PDF'}
                      </button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
          {notas.length > 0 && (
            <div style={st.notas}>
              <h4 style={st.notasTitulo}>Notas</h4>
              {notas.map((n, i) => (
                <p key={i} style={st.notaLinea}><b>{n.titulo}:</b> {n.texto}</p>
              ))}
            </div>
          )}
          <div style={{ ...st.accionesResultado, marginTop: 12 }}>
            <button style={st.btnSecondary} className="sim-btn-secondary" onClick={descargarPdf} disabled={descargandoPdf}>
              {descargandoPdf ? 'Generando PDF...' : '📄 Descargar desglose en PDF'}
            </button>
          </div>
          </>
        )
      )}

      {modalPlazos && tasaUnica && (
        <div style={st.modalFondo} onClick={() => setModalPlazos(null)}>
          <div style={st.modalCaja} onClick={(e) => e.stopPropagation()}>
            {modalPlazos === 'pregunta' ? (
              <>
                <h4 style={st.modalTitulo}>Comparar con varios plazos</h4>
                <p style={st.modalTexto}>
                  ¿Deseas comparar <b>{tasaUnica.banco} - {tasaUnica.tipo_credito}</b> con varios plazos además de {plazoAnios} años?
                </p>
                <div style={st.modalAcciones}>
                  <button style={st.btnSecondary} onClick={() => { setModalPlazos(null); ejecutarCalculo([plazoMeses]); }}>No, solo {plazoAnios} años</button>
                  <button style={st.btnPrimary} onClick={() => setModalPlazos('seleccion')}>Sí, elegir plazos</button>
                </div>
              </>
            ) : (
              <>
                <h4 style={st.modalTitulo}>Plazos adicionales</h4>
                <p style={st.modalTexto}>
                  Selecciona hasta {MAX_PLAZOS_ADICIONALES} plazos para comparar contra {plazoAnios} años
                  ({plazosExtraSel.length}/{MAX_PLAZOS_ADICIONALES}).
                </p>
                <div style={st.modalPlazosGrid}>
                  {plazosExtraDisponibles.map((anio) => {
                    const marcado = plazosExtraSel.includes(anio);
                    const bloqueado = !marcado && plazosExtraSel.length >= MAX_PLAZOS_ADICIONALES;
                    return (
                      <label key={anio} style={{ ...st.checkLabel, opacity: bloqueado ? 0.45 : 1, cursor: bloqueado ? 'not-allowed' : 'pointer' }}>
                        <input type="checkbox" checked={marcado} disabled={bloqueado} onChange={() => togglePlazoExtra(anio)} />
                        {anio} años
                      </label>
                    );
                  })}
                </div>
                <div style={st.modalAcciones}>
                  <button style={st.btnSecondary} onClick={() => setModalPlazos('pregunta')}>Regresar</button>
                  <button
                    style={{ ...st.btnPrimary, opacity: plazosExtraSel.length ? 1 : 0.5 }}
                    disabled={!plazosExtraSel.length}
                    onClick={confirmarPlazos}
                  >
                    Comparar
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SimuladorComparador;
